import { render, staticRenderFns } from "./cordova.vue?vue&type=template&id=7273b139"
import script from "./cordova.vue?vue&type=script&lang=js"
export * from "./cordova.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports